import axios from 'axios';
import { auth } from '../lib/firebase';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const axiosInstance = axios.create({
  baseURL: API,
});

axiosInstance.interceptors.request.use(async (config) => {
  // If user is in auctioneer mode, skip Firebase entirely — auctioneer is a
  // separate event-scoped login system that uses X-Auctioneer-* headers.
  const auctioneerSession = localStorage.getItem('auctioneer_session');
  const localToken = localStorage.getItem('token');
  const isAuctioneerMode = !!auctioneerSession || localToken === 'auctioneer_token';

  let token = null;
  if (!isAuctioneerMode) {
    // Prefer a fresh Firebase ID token (auto-refreshes if expired). Fall back
    // to whatever's in localStorage so legacy JWT sessions keep working
    // during the 1-week rollback window.
    try {
      if (auth?.currentUser) {
        token = await auth.currentUser.getIdToken();
        localStorage.setItem('token', token);
      }
    } catch (_e) {
      // Token fetch failed — fall through to localStorage.
    }
    if (!token) token = localToken;
  }

  if (token && token !== 'auctioneer_token') {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Add auctioneer credentials if logged in as auctioneer
  if (auctioneerSession) {
    try {
      const session = JSON.parse(auctioneerSession);
      if (session.username && session.password) {
        config.headers['X-Auctioneer-Username'] = session.username;
        config.headers['X-Auctioneer-Password'] = session.password;
      }
    } catch (e) {
      console.error('Failed to parse auctioneer session:', e);
    }
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check if this is an auctioneer session
      const auctioneerSession = localStorage.getItem('auctioneer_session');
      if (auctioneerSession) {
        localStorage.removeItem('auctioneer_session');
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        window.location.href = '/auctioneer-login';
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/auth';
      }
    }
    return Promise.reject(error);
  }
);
